import { useFormContext, Controller, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, FormControl, Typography, TextField, IconButton } from '@mui/material';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { SCQ } from './queryTab.classes';

export const QueryTab = () => {
    const { control } = useFormContext();
    const { t } = useTranslation();

    const { fields, append, remove } = useFieldArray({
        name: 'queryParams',
        control,
    });

    const handleAddKeyValue = () => {
        append({ Name: '', Value: '' });
    };

    const handleRemoveKeyValue = (index: number) => {
        remove(index);
    };

    return (
        <Box className={SCQ.root} sx={{ width: '600px' }}>
            <Typography sx={{ fontWeight: 'bold', mb: 2 }}>Query Parameters</Typography>
            {fields.map((item, index) => (
                <Box
                    key={item.id}
                    className={SCQ.row}
                    data-query-index={index}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 2,
                        mb: 2,
                    }}
                >
                    <Typography sx={{ fontWeight: 'bold', alignSelf: 'center' }}>
                        {t('scheduleService.name')}:{' '}
                    </Typography>
                    <Controller
                        name={`queryParams.${index}.name`}
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                className={SCQ.nameInput}
                                variant="outlined"
                                size="small"
                                sx={{ width: '45%' }}
                                placeholder={t('scheduleService.name')}
                            />
                        )}
                    />
                    <Typography sx={{ fontWeight: 'bold', alignSelf: 'center' }}>
                        {t('scheduleService.value')}:{' '}
                    </Typography>
                    <Controller
                        name={`queryParams.${index}.value`}
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                className={SCQ.valueInput}
                                variant="outlined"
                                size="small"
                                sx={{ width: '45%' }}
                                placeholder={t('scheduleService.value')}
                            />
                        )}
                    />
                    <IconButton
                        className={SCQ.removeButton}
                        onClick={() => handleRemoveKeyValue(index)}
                        color="error"
                        sx={{
                            '& .MuiSvgIcon-root': {
                                height: '18px',
                                width: '18px',
                            },
                        }}
                    >
                        <RemoveCircleIcon className={SCQ.removeIcon} />
                    </IconButton>
                </Box>
            ))}
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <IconButton
                    className={SCQ.addButton}
                    onClick={handleAddKeyValue}
                    color="primary"
                    sx={{
                        '& .MuiSvgIcon-root': {
                            height: '18px',
                            width: '18px',
                        },
                    }}
                >
                    <AddCircleIcon className={SCQ.addIcon} />
                </IconButton>
                <Typography
                    className={SCQ.addText}
                    onClick={handleAddKeyValue}
                    sx={{ ml: 1, fontWeight: 'bold', cursor: 'pointer' }}
                >
                    {t('scheduleService.addValue')}
                </Typography>
            </FormControl>
        </Box>
    );
};
